import {
  PDFViewer,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
  Font,
} from "@react-pdf/renderer";
import moment from "moment";

import logo from "../../../../../../src/assets/images/Logo.jpeg";
import img2 from "../../../../../../src/assets/images/img2.jpeg";

import Beb from "../../../../../../src/assets/fonts/BebasNeue-Regular.ttf";
import Kanit from "../../../../../../src/assets/fonts/Kanit-Regular.ttf";
import Junge from "../../../../../../src/assets/fonts/Junge-Regular.ttf";

const styles = StyleSheet.create({
  page: {
    padding: 30,
    backgroundColor: "#FFFFFF",
  },
  header: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
  },
  header2: {
    marginVertical: 10,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  row: {
    flexDirection: "row",
    marginVertical: 5,
  },
});

const InvoicePrint = ({ data }) => {
  const {
    invoiceNumber,
    date,
    organisationName,
    totalAmount,
    createdBy,
    invoiceLines,
    userName,
    invoiceDate,
  } = data;

  Font.register(
    {
      family: "Beb",
      format: "truetype",
      src: Beb,
    },
    {
      family: "Kanit",
      format: "truetype",
      src: Kanit,
    }
  );

  const PdfText = (props) => {
    const { fontFamily, fontSize, fontWeight, color } = props;
    const style = {
      fontFamily: fontFamily,
      fontSize: fontSize || 12,
      fontWeight: fontWeight,
      color: color,
    };
    return (
      <Text style={style} {...props}>
        {props.children}
      </Text>
    );
  };

  const SignatureArea = () => {
    return (
      <View style={styles.row}>
        <View style={{ flexGrow: 1, justifyContent: "center", alignItems: "center" }}>
          <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Customer Signature</Text>
        </View>
        <View style={{ flexGrow: 1, justifyContent: "center", alignItems: "center" }}>
          <Text style={{ fontFamily: "Open Sans", fontSize: 8 }}>Authorised Signature</Text>
        </View>
      </View>
    );
  };

  const Header = () => {
    return (
      <View style={styles.header}>
        <Image
          source={logo}
          style={{
            height: 40,
            // width: 40,
            objectFit: "cover",
          }}
        />
        <PdfText fontSize={24}>INVOICE</PdfText>
      </View>
    );
  };

  const Header2 = () => {
    return (
      <View style={styles.header2}>
        <View>
          <PdfText fontSize={12}>BILLED TO</PdfText>
          <View style={{ height: 5 }} />
          <PdfText fontSize={12}>{organisationName}</PdfText>
        </View>
        <View style={{ alignItems: "flex-end" }}>
          <PdfText fontSize={12}>Invoice Number : #{invoiceNumber}</PdfText>
          <View style={{ height: 5 }} />
          <PdfText fontSize={12}> {organisationName}</PdfText>
        </View>
      </View>
    );
  };

  const Header_bk = () => {
    return (
      <View style={styles.header}>
        <PdfText fontFamily="Beb" fontSize={14}>
          Invoice Date : {date}
        </PdfText>
        <View style={styles.row}>
          <PdfText fontSize={12}>Invoice Number</PdfText>
          <PdfText fontSize={12}># {invoiceNumber}</PdfText>
        </View>
        <View style={styles.row}>
          <PdfText fontSize={12}>Customer Organisation :</PdfText>
          <PdfText fontSize={12}> {organisationName}</PdfText>
        </View>
      </View>
    );
  };

  const tableStyles = StyleSheet.create({
    conatiner: {
      paddingVertical: 5,
      flex: 1,
    },
    tableHeader: {
      borderBottomWidth: 2,
      borderTopWidth: 2,
      borderColor: "#00B9B3",
      paddingVertical: 5,
      marginTop: 20,
      borderOpacity: 0.5,
    },
    summary: {
      borderTopWidth: 2,
      borderColor: "#00B9B3",
      borderOpacity: 0.5,
      paddingVertical: 10,
      flexDirection: "row",
    },
    serialColumn: {
      width: "20%",
      justifyContent: "center",
      alignItems: "center",
    },
    customerName: {
      width: "13.5%",
      justifyContent: "center",
      alignItems: "center",
    },
    tickerNumber: {
      width: "10%",
      justifyContent: "center",
      alignItems: "center",
    },
    charge: {
      width: "10%",
      justifyContent: "center",
      alignItems: "center",
    },
    walletAndDate: {
      width: "12.5%",
      justifyContent: "center",
      alignItems: "center",
    },
    total: {
      width: "14%",
      justifyContent: "center",
      alignItems: "center",
    },
    tableRow: {
      paddingVertical: 5,
      flexDirection: "row",
      justifyContent: "space-between",
      borderBottomWidth: 0.5,
      borderBottomColor: "#E7E7E7",
      paddingVertical: 10,
    },
    summaryBlankColumn: {
      width: "70%",
    },
    summaryCharge: {
      justifyContent: "center",
      alignItems: "center",
      width: "10%",
    },
    summaryTotal: {
      justifyContent: "center",
      alignItems: "center",
      width: "20%",
    },
  });

  const TableHeader = () => {
    return (
      <View style={tableStyles.tableHeader}>
        <View style={styles.row}>
          <View style={tableStyles.serialColumn}>
            <PdfText fontSize={9} color="#2369B9" fontFamily="Beb">
              Service Name
            </PdfText>
          </View>
          <View style={tableStyles.customerName}>
            <PdfText fontSize={9} color="#2369B9" fontFamily="Beb">
              Customer Name
            </PdfText>
          </View>
          <View style={tableStyles.tickerNumber}>
            <PdfText fontSize={9} color="#2369B9" fontFamily="Beb">
              Ticket Number
            </PdfText>
          </View>
          <View style={tableStyles.charge}>
            <PdfText fontSize={9} color="#2369B9" fontFamily="Beb">
              Service Charge
            </PdfText>
          </View>
          <View style={tableStyles.charge}>
            <PdfText fontSize={9} color="#2369B9" fontFamily="Beb">
              Govt Charge
            </PdfText>
          </View>
          <View style={tableStyles.charge}>
            <PdfText fontSize={9} color="#2369B9" fontFamily="Beb">
              Tax
            </PdfText>
          </View>
          <View style={tableStyles.walletAndDate}>
            <PdfText fontSize={9} color="#2369B9" fontFamily="Beb">
              Fine
            </PdfText>
          </View>
          {/* <View style={tableStyles.charge}>
            <PdfText fontSize={9} color="#2369B9" fontFamily="Beb">
              Discount
            </PdfText>
          </View> */}
          {/* <View style={tableStyles.walletAndDate}>
            <PdfText fontSize={9} color="#2369B9" fontFamily="Beb">
              Wallet Balance
            </PdfText>
          </View> */}
          <View style={tableStyles.total}>
            <PdfText fontSize={9} color="#2369B9" fontFamily="Beb">
              Total
            </PdfText>
          </View>
        </View>
      </View>
    );
  };

  const TableRow2 = ({ row, index }) => {
    const {
      ticketNumber,
      serviceCharge,
      govtCharge,
      taxOnServiceCharge,
      discount,
      createDateTime,
      walletBalance,
      total,
      fine,
      serviceName,
      transactionNumber,
      customerName,
    } = row;
    return (
      <View style={tableStyles.tableRow}>
        <View style={styles.row}>
          <View style={tableStyles.serialColumn}>
            <PdfText fontSize={10}>{serviceName}</PdfText>
            <PdfText fontSize={8}>( trsn: {transactionNumber.split("")} )</PdfText>
          </View>
          <View style={tableStyles.customerName}>
            <PdfText fontSize={10}>{customerName}</PdfText>
          </View>
          <View style={tableStyles.tickerNumber}>
            <PdfText fontSize={10}>{ticketNumber}</PdfText>
          </View>
          <View style={tableStyles.charge}>
            <PdfText fontSize={10}>{serviceCharge}</PdfText>
          </View>
          <View style={tableStyles.charge}>
            <PdfText fontSize={10}>{govtCharge}</PdfText>
          </View>
          <View style={tableStyles.charge}>
            <PdfText fontSize={10}>{taxOnServiceCharge}</PdfText>
          </View>
          <View style={tableStyles.walletAndDate}>
            <PdfText fontSize={10}>{fine}</PdfText>
          </View>
          {/* <View style={tableStyles.charge}>
            <PdfText fontSize={10}>{discount}</PdfText>
          </View> */}
          {/* <View style={tableStyles.walletAndDate}>
            <PdfText fontSize={10}>{walletBalance}</PdfText>
          </View> */}
          <View style={tableStyles.total}>
            <PdfText fontSize={10}>{total}</PdfText>
          </View>
        </View>
      </View>
    );
  };

  const TableRow = ({ row, index }) => {
    const {
      ticketNumber,
      serviceCharge,
      govtCharge,
      taxOnServiceCharge,
      discount,
      createDateTime,
      walletBalance,
      total,
      fine,
      serviceName,
      transactionNumber,
      customerName,
    } = row;
    return (
      <View style={{ backgroundColor: "#F5F5F5", padding: 10, borderRadius: 10, marginTop: 10 }}>
        <View style={tableStyles.tableRow}>
          <PdfText>Service Name</PdfText>
          <PdfText>{serviceName}</PdfText>
        </View>
        <View style={tableStyles.tableRow}>
          <PdfText>Customer Name</PdfText>
          <PdfText>{customerName}</PdfText>
        </View>
        <View style={tableStyles.tableRow}>
          <PdfText>Ticket Number</PdfText>
          <PdfText>{ticketNumber}</PdfText>
        </View>
        <View style={tableStyles.tableRow}>
          <PdfText>Service Charge</PdfText>
          <PdfText>{serviceCharge}</PdfText>
        </View>
        <View style={tableStyles.tableRow}>
          <PdfText>Govt Charge</PdfText>
          <PdfText>{govtCharge}</PdfText>
        </View>
        <View style={tableStyles.tableRow}>
          <PdfText>Tax</PdfText>
          <PdfText>{taxOnServiceCharge}</PdfText>
        </View>
        <View style={tableStyles.tableRow}>
          <PdfText>Fine</PdfText>
          <PdfText>{fine}</PdfText>
        </View>
        <View style={{ flexDirection: "row", justifyContent: "flex-end", paddingVertical: 15 }}>
          <PdfText fontSize={14}>Total : </PdfText>
          <PdfText fontSize={14}>{total}</PdfText>
        </View>
      </View>
    );
  };

  const SummaryRow = ({ summary }) => {
    return (
      <View style={{ flexDirection: "row", justifyContent: "flex-end", marginVertical: 20 }}>
        <PdfText fontSize={18} color="#2369B9" fontFamily="Beb">
          GRAND TOTAL :
        </PdfText>
        <PdfText fontSize={18} color="#2369B9" fontFamily="Beb">
          {summary}
        </PdfText>
      </View>
    );
  };

  const Footer = ({}) => {
    return (
      <View
        style={{
          flex: 1,
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "flex-end",
        }}
      >
        <PdfText fontSize={10}>{userName}</PdfText>
        <PdfText fontSize={10}>
          Date : {moment.utc(invoiceDate).local().format("YYYY-MM-DD HH:mm")}
        </PdfText>
      </View>
    );
  };

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Header />
        <Header2 />
        <View style={{ borderBottomWidth: 1, paddingVertical: 10, borderColor: "gray" }}>
          <PdfText fontSize={12}>TICKET DETAILS</PdfText>
        </View>
        {invoiceLines.map((row, index) => (
          <TableRow index={index} row={row} />
        ))}
        <SummaryRow summary={totalAmount} />
        <Footer />
        {/* <InvoiceDetails /> */}
      </Page>
    </Document>
  );
};

export default InvoicePrint;
